import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private readonly authenticationService: AuthenticationService) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const tokenResponse = this.authenticationService.token;

    if (request.url.includes('quick-actions')) {
      return next.handle(request);
    }

    if (tokenResponse?.data?.accessToken) {
      request = request.clone({
        setHeaders: {
          'X-Authorization': `${tokenResponse.data.accessToken}`,
        },
      });
    }

    return next.handle(request);
  }
}
